<template>
<b-card class="question d-flex mb-4 edit-quesiton" no-body>
    <div class="d-flex flex-grow-1 min-width-zero" >
        <div class="card-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center pr-2">
            <div class="list-item-heading mb-0 truncate w-100 mb-1 mt-1">
                <span class="heading-number d-inline-block">{{sort}}</span>{{description}}
            </div>
        </div>
        
        <div class="mb-1 display-table-cell text-muted text-small w-15 pr-2">
            <b-progress style="height:10px;border:1px solid #ddd;" >
                <b-progress-bar :value="calculeProgress" variant="theme-5"></b-progress-bar>
            </b-progress>
        </div>

        <div class="custom-control custom-checkbox pl-1 align-self-center pr-4">
            

            <b-button v-if="!operation_id" variant="outline-theme-3" class="icon-button rotate-icon-click rotate"
                @click="showDetail = !showDetail"
                :aria-controls="`questionCollapse${sort}`"
                :aria-expanded="showDetail ? 'true' : 'false'"
            >
                <i :class="{'with-rotate-icon':true,'simple-icon-arrow-down':!showDetail,'simple-icon-arrow-up':showDetail}"></i>
            </b-button>
            <b-button v-if="operation_id" variant="outline-theme-3" class="icon-button" @click="visitOperation()">
                <i class="simple-icon-eye"></i>
            </b-button>
        </div>
    </div>
    <b-collapse :id="`questionCollapse${sort}`" class="question-collapse" v-model="showDetail" >
        <div class="card-body pt-0">
            <div v-if="mode=='edit'" key="edit">
                <div class="form-group mb-3">
                    <label>Description:</label>
                    <b-input v-model="description"/>
                </div>
                <div class="form-group mb-3">
                    <label>Nombre des rendez-vous:</label>
                    <b-input v-model="nb_rdv"/>
                </div>
                <div class="form-group mb-3">
                    <label>Prix totale:</label>
                    <b-input v-model="prixtotale"/>
                </div>
                <div class="form-group mb-4">
                    <label>Decalage de chaque rendez-vous:</label>
                    <b-input v-model="decalage"/>
                </div>
                <hr>
                <h3 class="mb-3 mt-3">Premier rendez-vous:</h3>

                <b-form>
                    <b-form-group :label="'Date'">
                      <datepicker
                        class="form-control ml-0"
                        v-model="rdv.date"
                        :language="fr"
                      ></datepicker>
                    </b-form-group>
                    <b-form-group :label="'Heure'">
                      <el-time-select
                        v-model="rdv.heure"
                        :picker-options="{
                          start: '08:30',
                          step: '00:15',
                          end: '18:30',
                        }"
                        placeholder="Selectionner une heure"
                        class="w-100"
                      >
                      </el-time-select>
                    </b-form-group>
                </b-form>

                <b-button variant="outline-primary" size="sm" class="mb-2" @click="addOperation">Confirmer</b-button>
            </div>
            <div  v-else-if="mode=='preview'" key="preview">
                <label>{{nb_rdv}}</label>

                <b-input key="text-input-preview" v-if="answerType.value==0"/>
                <v-select :options="answers" key="single-select-preview" v-else-if="answerType.value==1"/>
                <v-select :options="answers" key="multiple-select-preview" v-else-if="answerType.value==2"/>
                <b-form-checkbox-group  stacked key="checkbox-preview" v-else-if="answerType.value==3">
                    <b-form-checkbox :value="a.value" v-for="(a,index) in answers" :key="`ans_${index}`">{{a.label}}</b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-radio-group stacked  key="radiobutton-preview"  v-else-if="answerType.value==4">
                    <b-form-radio  :value="a.value" v-for="(a,index) in answers" :key="`ans_${index}`">{{a.label}}</b-form-radio>
                </b-form-radio-group>

            </div>
        </div>
    </b-collapse>
</b-card>
</template>

<script>
import Vue from "vue";
import { fr } from "vuejs-datepicker/dist/locale";
import ElementUI from "element-ui";
import Datepicker from "vuejs-datepicker";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI);


import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { apiUrl } from "@/constants/config";

const questionTypes = [{ label: 'Text Input', value: 0, options: false },
  { label: 'Single Select', value: 1, options: true },
  { label: 'Multiple Select', value: 2, options: true },
  { label: 'Checkbox', value: 3, options: true },
  { label: 'Radiobutton', value: 4, options: true }]

export default {
  props: ['data', 'sort','id'],
  components: {
    vSelect,
    Datepicker
  },
  data () {
    return {
      fr:fr,
      questionTypes,
      mode: 'edit', // edit,
      showDetail: false,
      description: '',
      decalage:3,
      nb_rdv: '',
      rdv:{
        date:new Date(),
        heure:"09:00"
      },
      prixtotale:null,
      answers: null,
      answerType: questionTypes[0],
      operation_id:null
    }
  },
  mounted () {
    this.description = this.data.description
    this.nb_rdv = this.data.nb_rdv
    this.prixtotale = this.data.prixtotale 
    this.operation_id = this.id
    if(this.data && this.data.showDetail){
        this.showDetail = this.data.showDetail
    }
    // this.answers = this.data.answers
    // this.answerType = questionTypes.find(x => x.value === this.data.answerType)
  },
  methods: {
    visitOperation(){
        this.$router.push({name:"rdv",params:{id:this.operation_id}})
    },
    addOperation(){
        let rdv = {...this.rdv}
        let obj = {
            description:this.description,
            prixtotale:parseFloat(this.prixtotale),
            nb_rdv:parseInt(this.nb_rdv),
            decalage:parseInt(this.decalage),
            patientId:this.$route.params.id,
            rdv:rdv
        }
        let currentEndpoint = `${apiUrl}/operations/`
        this.sendRequest('post',currentEndpoint,obj)
        .then(res => {
            console.log("posted",res)
            if(res.data && res.data !==""){
                this.operation_id = res.data.id
                this.visitOperation()
            }
            // if(res.data !== ""){       
            //     this.currentPatient = res.data
            //     this.currentPatient.operations = []
            // }
        }).catch(err=>{
            console.log("iam the error",err)
        })
    },
    changeMode (mode) {
      this.mode = mode
      this.showDetail = true
    },
    deleteAnswer (value) {
      this.answers = this.answers.filter(x => x.value !== value)
    },
    addAnswer () {
      this.answers.push({ value: this.answers.length + 1, label: '' })
    }
  },
  watch: {
    showDetail (val) {
      if (!val) {
      }
    }
  },
  computed:{
      calculeProgress(){
        let max = this.data.nb_rdv ? this.data.nb_rdv : 1
        let complete = 0.1
        if(this.data.rdvs){
            for(let i=0;i<this.data.rdvs.length;i++){
                if(this.data.rdvs[i].isconfirmed){
                    complete++
                }
            }
        }
        let total = (complete*100)/max
        return total || 1
    }
  }
}
</script>
